import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CustomScrollbars from "util/CustomScrollbars";
import Cookies from "js-cookie";
import { withTranslation } from "react-i18next";

class SidenavContent extends Component {
  componentDidMount() {
    const { history } = this.props;
    const pathname = `#${history.location.pathname}`;

    const subMenuLi = document.querySelectorAll(".sub-menu > li");
    for (let i = 0; i < subMenuLi.length; i++) {
      subMenuLi[i].onclick = function (event) {
        event.stopPropagation();
      };
    }

    const menuLi = document.getElementsByClassName("menu");
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = this.closest("li");
          if (
            menuLi[j] !== this &&
            (parentLi === null || !parentLi.classList.contains("open"))
          ) {
            menuLi[j].classList.remove("open");
          }
        }
        this.classList.toggle("open");
        event.stopPropagation();
      };
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]');
    try {
      const activeNav = this.closest(activeLi, "ul");
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) { }
  }

  closest(el, selector) {
    try {
      let matchesFn;
      [
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector",
      ].some(function (fn) {
        if (typeof document.body[fn] == "function") {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) { }

    return null;
  }

  render() {
    const featureAccess = Cookies.get("featureAccess");
    const { t } = this.props;

    return (
      <CustomScrollbars className="scrollbar">
        <ul className="nav-menu">
          <li>
            <NavLink to="/app/dashboard/index">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">{t("nav.dashboard")}</span>
            </NavLink>
          </li>

          {featureAccess === "m&d" && (
            <>
              <li className="menu collapse-box">
                <Button href="javascript:void(0)" className="cbutton">
                  <i className="zmdi zmdi-collection-item zmdi-hc-fw" />
                  <span className="nav-text">{t("nav.products.title")}</span>
                </Button>
                <ul className="sub-menu">
                  <li>
                    <NavLink className="prepend-icon cbutton" to="/app/products/list">
                      <i className="zmdi zmdi-view-list" />
                      <span className="nav-text">{t("nav.products.all")}</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="prepend-icon cbutton" to="/app/products/add">
                      <i className="zmdi zmdi-plus-circle" />
                      <span className="nav-text">{t("nav.products.add")}</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="prepend-icon cbutton" to="/app/products/import">
                      <i className="zmdi zmdi-cloud-upload" />
                      <span className="nav-text">{t("nav.products.import")}</span>
                    </NavLink>
                  </li>
                </ul>
              </li>

              <li>
                <NavLink to="/app/orders/all">
                  <i className="zmdi zmdi-view-list zmdi-hc-fw" />
                  <span className="nav-text">{t("nav.orders")}</span>
                </NavLink>
              </li>
            </>
          )}

          <li>
            <NavLink to="/app/deliveries/all">
              <i className="zmdi zmdi-car zmdi-hc-fw" />
              <span className="nav-text">{t("nav.deliveries.all")}</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/app/deliveries/add">
              <i className="zmdi zmdi-car zmdi-hc-fw" />
              <span className="nav-text">{t("nav.deliveries.quickAdd")}</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/app/expenses/all">
              <i className="zmdi zmdi-money-box zmdi-hc-fw" />
              <span className="nav-text">Expenses</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/app/patients/all">
              <i className="zmdi zmdi-account zmdi-hc-fw" />
              <span className="nav-text">{t("nav.patients")}</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/app/payments/report">
              <i className="zmdi zmdi-money zmdi-hc-fw" />
              <span className="nav-text">{t("nav.payments.report")}</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/app/recurring/all">
              <i className="zmdi zmdi-replay zmdi-hc-fw" />
              <span className="nav-text">{t("nav.recurring")}</span>
            </NavLink>
          </li>

          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-balance-wallet" />
              <span className="nav-text">{t("nav.payments.title")}</span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/payments/add-payment">
                  <i className="zmdi zmdi-money-box" />
                  <span className="nav-text">{t("nav.payments.make")}</span>
                </NavLink>
                <NavLink className="prepend-icon cbutton" to="/app/settings/profile/add-card">
                  <i className="zmdi zmdi-money-box" />
                  <span className="nav-text">{t("nav.payments.addCard")}</span>
                </NavLink>
              </li>

              <li>
                <NavLink className="prepend-icon cbutton" to="/app/payments/all">
                  <i className="zmdi zmdi-replay" />
                  <span className="nav-text">{t("nav.payments.history")}</span>
                </NavLink>
              </li>
            </ul>
          </li>

          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-settings zmdi-hc-fw" />
              <span className="nav-text">{t("nav.settings.title")}</span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/settings/profile/edit">
                  <i className="zmdi zmdi-account-circle" />
                  <span className="nav-text">{t("nav.settings.profile")}</span>
                </NavLink>
              </li>

              <li>
                <NavLink className="prepend-icon cbutton" to="/app/notifications/list">
                  <i className="zmdi zmdi-account-circle" />
                  <span className="nav-text">{t("nav.settings.notifications")}</span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/settings/password-update">
                  <i className="zmdi zmdi-album" />
                  <span className="nav-text">{t("nav.settings.updatePassword")}</span>
                </NavLink>
              </li>
            </ul>
          </li>

          <li>
            <a href="https://meds-on-wheels.com/mdsadmin/login" target="_blank">
              <i className="zmdi zmdi-arrow-right-top zmdi-hc-fw" />
              <span className="nav-text">{t("nav.oldPanel")}</span>
            </a>
          </li>
        </ul>
      </CustomScrollbars>
    );
  }
}

export default withRouter(withTranslation()(SidenavContent));
